










import { Component, Prop, Vue } from 'vue-property-decorator';
import ProductForm from '@/components/Product/ProductForm.vue';
import { UNIT_INVOICE_SETTINGS } from '@/queries/CompanySetting';
import { GQL_unitInvoiceSetting, GQL_unitInvoiceSetting_currentUnit } from '@/queries/__generated__/unitInvoiceSetting';
import { SmartQuery } from 'vue-apollo-decorator';
import SPopup from '@/components/UI/Popup/SPopup.vue';
import Decimal from '@/utils/decimal';
import gql from 'graphql-tag';
import { productFragments } from '@/queries/Product';

const CREATE_PRODUCT = gql`
  mutation createProduct(
    $unitId: ID!,
    $number: String!,
    $name: String!,
    $description: String,
    $vatRateSymbol: NorwegianVatSymbolEnum!,
    $taxExemptionReason: String,
    $productPrices: [ProductPriceCreate!],
    $unitOfMeasureCode: String!,
    $carId: ID,
    $projectId: ID,
    $departmentId: ID,
    $productGroupId: ID,
    $supplierUnitId: ID,
    $images: [FileUpload!],
    $suppliersProductNumber: String,
    $productActivePeriods: [ProductActivePeriodCreate!]
  ) {
    createProduct(
      input: {
        product: {
          unitId: $unitId,
          number: $number,
          name: $name,
          description: $description,
          vatRateSymbol: $vatRateSymbol,
          taxExemptionReason: $taxExemptionReason,
          productPrices: $productPrices,
          unitOfMeasureCode: $unitOfMeasureCode,
          carId: $carId,
          projectId: $projectId,
          departmentId: $departmentId,
          productGroupId: $productGroupId,
          supplierUnitId: $supplierUnitId,
          images: $images,
          suppliersProductNumber: $suppliersProductNumber,
          productActivePeriods: $productActivePeriods
        }
      }
    ) {
      product {
        ...productFragments
      }
    }
  },
  ${productFragments}
`;

@Component({
  components: {
    ProductForm,
  },
})
export default class ProductNew extends Vue {
  @SmartQuery<ProductNew, GQL_unitInvoiceSetting>({
    query: UNIT_INVOICE_SETTINGS,
    result({ data }) {
      this.data.unitId = data.currentUnit.id;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.data as any).unitOfMeasureCode = data.currentUnit.unitSetting.unitInvoiceSetting.defaultProductUnitOfMeasureCode;
    },
  }) public currentUnit!: GQL_unitInvoiceSetting_currentUnit;

  @Prop() private parentPopup!: SPopup

  public CREATE_PRODUCT = CREATE_PRODUCT;
  public data = {
    unitId: '',
    number: null,
    name: null,
    vatRateSymbol: null,
    taxExemptionReason: null,
    productPrices: [ {
      id: null,
      validFrom: this.$dayjs().format('YYYY-MM-DD'),
      validTo: null,
      salePrice: new Decimal(0),
      purchasePrice: new Decimal(0),
      _destroy: false,
    } ],
    unitOfMeasureCode: null,
    car: null,
    project: null,
    department: null,
    images: [],
    productActivePeriods: [
      {
        id: null,
        activeFrom: this.$dayjs().format('YYYY-MM-DD'),
        activeTo: null,
      },
    ],
  };
}
